/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountwithemailexists3Inputs */

const en_accountwithemailexists3 = /** @type {(inputs: Accountwithemailexists3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An account with this email already exists.`)
};

const de_accountwithemailexists3 = /** @type {(inputs: Accountwithemailexists3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Konto mit dieser E-Mail-Adresse existiert bereits.`)
};

/**
* | output |
* | --- |
* | "An account with this email already exists." |
*
* @param {Accountwithemailexists3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const accountwithemailexists3 = /** @type {((inputs?: Accountwithemailexists3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountwithemailexists3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_accountwithemailexists3(inputs)
	return de_accountwithemailexists3(inputs)
});
export { accountwithemailexists3 as "accountWithEmailExists" }